import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatDatePipe } from './formatar-data.service';



@NgModule({
    imports: [
        CommonModule,
        FormatDatePipe
    ],
    exports: [FormatDatePipe],
    providers: [FormatDatePipe]
})
export class FormatarDataModule { }
